<template>
    <div>
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end" v-if="is_admin">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <!-- overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->
        <v-card class="box" v-if="ay_list.length != 0">
            <v-toolbar flat class="toolbar">
                <v-toolbar-title v-if="tenant == 'sbpps'">
                    School-Parent Communication
                </v-toolbar-title>
                <v-toolbar-title v-else>
                    Teacher`s Diary
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon style="float:right;" @click="init" color="yellow">mdi-reload</v-icon>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2" md="2" lg="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="cay" :items="ay_list"
                            label="Select AY" outlined persistent-hint hint="Please Select AY" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" lg="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="msg_type"
                            :items="diary_msg_types" label="Select Type" outlined persistent-hint
                            hint="Please Select Message Type" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                        <v-icon color="error">*</v-icon>
                        From Date (including)::
                        <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                        <v-icon color="error" class="ml-3">*</v-icon>
                        To Date (excluding)::
                        <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="todate" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" lg="2">
                        <v-btn class="mt-5 pt-0 button" @click="getTeacherDairy" dense>Proceed</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="addTeacherDairyInit" :disabled="isvalid == false ? true : false"
                        dense>Compose Message</v-btn>
                </v-row><br>
                <v-row v-if="!isvalid" align="center" justify="space-around">
                    <p v-if="!isvalid"><b>{{Message}}</b></p>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="dairy_data.length != 0">
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>
                    Teacher`s Diary | AY:{{ cay }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field class="white" v-model="search" append-icon="search" label="Search in table" rounded
                    single-line hide-details></v-text-field>
            </v-toolbar>
            <v-card-text>
                <!-- <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search" :items="dairy_data"
                    :items-per-page="-1" fixed-header> -->
                <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search" :items="dairy_data"
                    :items-per-page="-1" fixed-header show-select item-key="dairy_id" v-model="selectedRows">
                    <!-- Only allow selection if message is from School to Parent -->
                    <template v-slot:item.data-table-select="{ item, isSelected, select }">
                        <div class="d-flex align-center justify-center">
                            <v-simple-checkbox v-if="item.diarymessagetype === 'School to Parent'" :value="isSelected"
                                @input="select($event)" color="primary" :ripple="false"></v-simple-checkbox>
                    
                            <v-icon v-else color="grey"
                                title="Parent messages cannot be selected or deleted by teacher">mdi-alert-circle-outline</v-icon>
                        </div>
                    </template>
                    <template v-slot:header.data-table-select="{ on, props }">
                        <div class="d-flex align-center">
                            <v-simple-checkbox v-bind="props" v-on="on" color="primary"></v-simple-checkbox>

                            <v-btn v-if="selectedRows.length > 0" icon medium color="dark red" class="ml-1"
                                @click.stop="deleteSelected">
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <template v-slot:[`item.diarymessagetype`]="{ item }">
                        <v-chip :color="getColor(item.diarymessagetype)">
                            {{ item.diarymessagetype }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.message`]="{ item }">
                        <v-icon color="blue" @click="showDairy(item)">mdi-eye</v-icon>
                    </template>
                    <template v-slot:[`item.attachment`]="{ item }">
                        <a v-if="item.attachment_file_name != null" target="_blank"
                            :href="awspath + item.attachment_file_path + item.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                    </template>
                    <template v-slot:[`item.url`]="{ item }">
                        <a v-if="item.url != null" :href="item.url" target="_blank">{{ item.url }}</a>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon color="red" v-if="item.diarymessagetype == 'School to Parent'"
                            @click="deleteDairy(item)">mdi-trash-can</v-icon>
                        <v-icon v-else>mdi-alert-circle-outline</v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="msg_dialog" v-if="msg_data != null" max-width="1200px">
            <v-card>
                <v-toolbar flat class="toolbar">
                    <v-card-title>Message [{{ msg_data.diarymessagetype }}]</v-card-title>
                </v-toolbar>
                <v-card-text>
                    <v-card class="box">
                        <v-row justify="center">
                            <v-col sm="3" md="3">
                                Post date : <b>{{ msg_data.post_date }}</b>
                            </v-col>
                            <v-col sm="3" md="3">
                                Faculty : <b>{{ msg_data.instructor }}</b>
                            </v-col>
                            <v-col sm="3" md="3">
                                Student : <b>{{ msg_data.learner }}</b>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="3" md="3">
                                Standard : <b>{{ msg_data.learner_std }}</b>
                            </v-col>
                            <v-col sm="3" md="3">
                                Div : <b>{{ msg_data.learner_div }}</b>
                            </v-col>
                            <v-col sm="3" md="3">
                                Roll No : <b>{{ msg_data.learner_roll }}</b>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9">
                                Subject :
                                <v-text-field style="font-weight:bold" outlined v-model="msg_data.subject"
                                    variant="outlined" readonly></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9">
                                Message :
                                <v-textarea style="font-weight:bold" outlined name="input-9-6" v-model="msg_data.msg"
                                    variant="outlined" readonly></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9" v-if="msg_data.url != null">
                                URL :
                                <a :href="msg_data.url" target="_blank">{{ msg_data.url }}</a>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="3" md="3" v-if="msg_data.isread == true">
                                Read On : <b>{{ msg_data.read_date }}</b>
                            </v-col>
                            <v-col sm="3" md="3" v-if="msg_data.attachment_file_name != null">
                                Attachment : <a target="_blank"
                                    :href="awspath + msg_data.attachment_file_path + msg_data.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card-text>
                <v-card-actions class="justify-center"><v-btn color="warning"
                        @click="msg_dialog = false">Close</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_compose_message" style="margin-top: 10%" fullscreen hide-overlay
            transition="dialog-top-transition">
            <v-card class="mx-auto">
                <v-toolbar dark color="brand onBrand--text">
                    <v-toolbar-title>Compose Message</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="dialog_compose_message = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <br />
                <v-card-text>
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" v-if="stud_list != ''">
                                <p><v-icon color="error">*</v-icon><b>Select Student</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="learners"
                                    :items="stud_list" item-text="stud" item-value="ld_id" label="Student" outlined
                                    persistent-hint hint="Please Select Student" multiple />
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><v-icon color="error">*</v-icon><b>Subject</b></p>
                                <v-text-field outlined v-model="subject" label="Enter Message Subject"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><v-icon color="error">*</v-icon><b>Description</b></p>
                                <v-textarea outlined name="input-7-4" v-model="description"
                                    label="Enter Description"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><b>URL</b></p>
                                <v-text-field outlined v-model="url" label="Enter URL"
                                    placeholder="https://example.com"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><b>Attachment If Any</b></p>
                                <v-file-input rounded dense outlined prepend-icon="mdi-attachment" label="Choose File"
                                    show-size v-model="file" name="doc"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense v-if="learners && description && subject">
                            <v-btn class="mt-5 pt-0 button" @click="addDiary()" dense :loading="loader">Send</v-btn>
                        </v-row>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Diary Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/NbFlX5O7fYk?si=jAHWop0WHphsRDYG"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        is_admin: false,
        isvalid: true,
        Message: null,
        learners: [],
        description: "",
        videoDialog:false,
        file: null,
        loader: false,
        subject: "",
        url: "", // Added URL field
        dialog_compose_message: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
        cay: null,
        ay_list: [],
        diary_msg_types: [],
        msg_type: null,
        dairy_data: [],
        search: '',
        msg_dialog: false,
        msg_data: null,
        selectedRows: [],
        headers: [
            {
                text: "Sr. No.",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Post Date",
                align: "left",
                sortable: false,
                value: "post_date",
            },
            {
                text: "Message Type",
                align: "left",
                sortable: false,
                value: "diarymessagetype",
            },
            {
                text: "Subject",
                align: "left",
                sortable: false,
                value: "subject",
            },
            {
                text: "Message",
                align: "left",
                sortable: false,
                value: "message",
            },
            {
                text: "Attachment",
                align: "left",
                sortable: false,
                value: "attachment",
            },
            {
                text: "URL",
                align: "left",
                sortable: false,
                value: "url",
            },
            {
                text: "Learner",
                align: "left",
                sortable: false,
                value: "learner",
            },
            {
                text: "Read On",
                align: "left",
                sortable: false,
                value: "read_date",
            },
            {
                text: "Action",
                align: "left",
                sortable: false,
                value: "action",
            },
        ],
        awspath: null,
        stud_list: null,
        tenant: null
    }),
    created() {
        this.awspath = localStorage.getItem('awspath')
    },
    methods: {
        async addDiary() {
            let formData = new FormData();
            if (this.learners.length <= 0 || (this.learners.length === 1 && this.learners[0] === '')) {
                this.showSnackbar("red", "Please select Student...");
                return;
            }
            if (this.learners.length > 1) {
                for (var i = 0; i < this.learners.length; i++) {
                    if (this.learners[i] != '') {
                        let stud = this.learners[i];
                        formData.append('learners', stud);
                    }
                }
            } else {
                formData.append("learners", this.learners);
            }
            formData.append("attachment_file", this.file);
            formData.append("description", this.description);
            formData.append("subject", this.subject);
            formData.append("url", this.url); // Added URL to form data
            formData.append("ay", this.cay);
            formData.append("from", "TTP");
            this.overlay = true;
            this.loader = true;
            try {
                const res = await axios.post("/dairy/addDiary", formData)
                if (res.data.flag == "YES") {
                    this.stud_list = res.data.stud_list
                    this.showSnackbar("green", res.data.snackbar);
                } else {
                    this.isvalid = res.data.isvalid;
                    this.Message = res.data.Message;
                    this.showSnackbar("red", res.data.Message);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                this.loader = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
                this.dialog_compose_message = false;
                this.learners = [];
                this.description = "";
                this.subject = "";
                this.url = ""; // Reset URL field
                this.file = null;
                this.getTeacherDairy();
                this.loader = false;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getColor(diarymessagetype) {
            if (diarymessagetype == "Parent to School")
                return "#A1C2F1"
            else
                return "#E1AEFF"
        },
        async showDairy(item) {
            const formdata = {
                diary_id: item.dairy_id
            }
            if (item.diarymessagetype == "Parent to School" && item.isread == false) {
                this.overlay = true;
                try {
                    const res = await axios.post("/dairy/readTeacherDairy", formdata)
                    if (res.data.flag == "YES") {
                        item.read_date = res.data.read_date
                        item.isread = true
                        this.showSnackbar("green", "Deleted Successfully");
                        this.msg_data = item
                        this.msg_dialog = true
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                }
                catch (err) {
                    console.log("err", err)
                    this.onerror(err);
                    this.overlay = false;
                }
                finally {
                    console.log("bye...")
                    this.overlay = false;
                }
            }
            else {
                this.msg_data = item
                this.msg_dialog = true
            }
        },
        async init() {
            this.stud_list = null
            this.dairy_data = []
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/initTeacherDairy")
                if (res.data.flag == "YES") {
                    this.diary_msg_types = res.data.diary_msg_types
                    this.diary_msg_types.unshift("All")
                    this.msg_type = this.diary_msg_types[0]
                    this.ay_list = res.data.ay_list
                    this.cay = res.data.cay
                    this.isvalid = res.data.isvalid
                    this.Message = res.data.Message
                    if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }
        },
        async getTeacherDairy() {
            const formdata = {
                fromdate: this.fromdate,
                todate: this.todate,
                ay: this.cay,
                msg_type: this.msg_type
            }
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/getTeacherDairy", formdata)
                if (res.data.flag == "YES") {
                    this.dairy_data = res.data.dairy_data
                    this.showSnackbar("green", res.data.snackbar);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }
        },
        async addTeacherDairyInit() {
            this.dialog_compose_message = true
            if (this.stud_list == null) {
                const formdata = {
                    ay: this.cay
                }
                this.overlay = true;
                try {
                    const res = await axios.post("/dairy/getLearner", formdata)
                    if (res.data.flag == "YES") {
                        this.stud_list = res.data.stud_list
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                }
                catch (err) {
                    console.log("err", err)
                    this.onerror(err);
                    this.overlay = false;
                }
                finally {
                    console.log("bye...")
                    this.overlay = false;
                }
            }
        },
        async deleteDairy(item) {
            const formdata = {
                diary_id: item.dairy_id
            }
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/deleteTeacherDairy", formdata)
                if (res.data.flag == "YES") {
                    await this.getTeacherDairy();
                    var index = this.dairy_data.indexOf(item)
                    this.dairy_data.splice(index, 1)
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }
        },
        async deleteSelected() {
      if (this.selectedRows.length === 0) return;
      if (!confirm(`Delete selected records?`)) return;

      this.overlay = true;
      try {
        const ids = this.selectedRows.map(r => r.dairy_id);
        const res = await axios.post("/dairy/deleteTeacherDairy", { diary_ids: ids });

        if (res.data.flag === "YES") {
            await this.getTeacherDairy();
          this.dairy_data = this.dairy_data.filter(item => !ids.includes(item.dairy_id));
          this.showSnackbar("green", `Selected diaries deleted successfully!`);
          this.selectedRows = [];
        } else {
          this.showSnackbar("red", res.data.snackbar);
        }
      } catch (err) {
        console.error(err);
        this.onerror(err);
      } finally {
        this.overlay = false;
      }
    },
    },
    mounted() {
        this.init()
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>
<style scoped></style>